const getMvcUrl = function() {
	return location.protocol + "//" + location.host ;
}
export default getMvcUrl
